import React, { useState, useEffect, useCallback } from "react";
import { getEnvBrandColor } from "../../helpers/envBrandColor";
import HeaderNavMenus from "./HeaderNavMenus";
import HeaderUserDropdownModernized from "./HeaderUserDropdownModernized";
import "../../../scss/components/_header-modernized.scss";

interface HeaderModernizedProps {
  designVariant?: "minimal" | "bold" | "gradient" | "split";
  bannerVisible?: boolean;
  bannerHeight?: number;
  toggleHelpVisible?: () => void;
  setHelpDataAll?: (value: boolean) => void;
}

function debounce(fn: Function, ms: number) {
  let timer: NodeJS.Timeout;
  return (...args: any[]) => {
    clearTimeout(timer);
    timer = setTimeout(() => {
      timer = null as any;
      fn.apply(null, args);
    }, ms);
  };
}

const HeaderModernized: React.FC<HeaderModernizedProps> = ({
  designVariant = "bold",
  bannerVisible = false,
  bannerHeight = 0,
  toggleHelpVisible,
  setHelpDataAll,
}) => {
  const [width, setWidth] = useState(window.innerWidth);

  const debouncedHandleResize = useCallback(
    debounce(() => {
      setWidth(window.innerWidth);
    }, 500),
    [],
  );

  useEffect(() => {
    window.addEventListener("resize", debouncedHandleResize);
    return () => {
      window.removeEventListener("resize", debouncedHandleResize);
    };
  }, [debouncedHandleResize]);

  const mobileSidebarToggle = (e: React.MouseEvent) => {
    e.preventDefault();
    document.body.classList.toggle("sidebar-mobile-show");
    if (document.body.classList.contains("sidebar-full")) {
      document.body.classList.toggle("sidebar-full");
    }
  };

  const isMobile = width <= 991;
  // Only set for next/cypress; prod uses --ajw-purple from design-tokens.css
  const envBrandColor = getEnvBrandColor();

  return (
    <header
      className={`header-modernized header-modernized-${designVariant}`}
      style={{
        position: "sticky",
        top: bannerVisible ? `${bannerHeight}px` : "0",
        zIndex: 1000,
        ...(envBrandColor
          ? { ["--env-brand-color" as string]: envBrandColor }
          : {}),
      }}
    >
      {/* Logo Area */}
      <div className={`header-logo-area header-logo-area-${designVariant}`}>
        <a
          href="/#/"
          className="header-logo-link"
          aria-label="Home"
        >
          <div
            className="header-logo"
            style={{ backgroundImage: "url(./img/logo.png)" }}
          />
        </a>
      </div>

      {/* Mobile Hamburger */}
      {isMobile && (
        <button
          className="header-mobile-toggle"
          onClick={mobileSidebarToggle}
          aria-label="Toggle sidebar"
          type="button"
        >
          <span className="header-hamburger-icon" id="hamburger">
            <span></span>
            <span></span>
            <span></span>
          </span>
        </button>
      )}

      {/* Environment Badge - Hidden for production-like appearance */}

      {/* Navigation Menus (Desktop) */}
      <div className="header-nav-area">
        <HeaderNavMenus className="d-md-down-none" nav-bar="true" />
      </div>

      {/* User Dropdown */}
      <div className="header-user-area">
        <HeaderUserDropdownModernized
          designVariant={designVariant}
          toggleHelpVisible={toggleHelpVisible}
          setHelpDataAll={setHelpDataAll}
        />
      </div>
    </header>
  );
};

export default HeaderModernized;
